import useDataFetcher from '~/components/useDataFetcher';
import type { ClaimStageConfigurationsResponse } from '~/server_shared/openapi/data-contracts';

import type { UseFetchClaimStageConfigurationsReturnType } from '../types';

const useFetchClaimStageConfigurations = ({
  organizationId,
  shouldFetch = true,
}: {
  organizationId: number;
  shouldFetch?: boolean;
}): UseFetchClaimStageConfigurationsReturnType => {
  const { data, isLoading, isError, reloadData } = useDataFetcher<ClaimStageConfigurationsResponse>(
    `/api/v1/organizations/${organizationId}/claim_stage/config`,
    null,
    shouldFetch
  );

  return {
    claimStageConfigurations: data?.stage_configurations || [],
    isLoading,
    isError,
    reloadData,
  };
};

export default useFetchClaimStageConfigurations;
